import type {ActionReturn} from 'svelte/action';

// this action manually adds [disabled] attribute to non-input elements for bootstrap styling (usual method is marked as invalid by svelte-check)
export function disabledAttribute(node: HTMLElement, isInitiallyDisabled: boolean): ActionReturn<boolean> {

    if (isInitiallyDisabled) {
        node.setAttribute('disabled', '');
    }

    return {
        update(isDisabled) {
            if (isDisabled) {
                node.setAttribute('disabled', '');
            } else {
                node.removeAttribute('disabled');
            }
        }
    }
}